import React from 'react';
import PageHero from '../../components/ui/PageHero';
import PageCTA from '../../components/ui/PageCTA';
import PortfolioSpotlight from '../../components/portfolio/PortfolioSpotlight';
import { liveProjectsCount } from '../../data/projects';

const Projects = () => (
  <div>
    <PageHero
      label="Our Portfolio"
      title="All Live"
      titleHighlight="Websites"
      description={`${liveProjectsCount} production sites — select any project to preview and visit live.`}
      breadcrumb="Portfolio"
    />

    <PortfolioSpotlight compactHeader showPageCta={false} sectionId="portfolio-grid" />

    <PageCTA
      title="Ready To Start Your Project?"
      description="Let's build something remarkable together."
      primaryLabel="Get Free Consultation"
      secondaryLabel="Our Services"
      secondaryTo="/services"
    />
  </div>
);

export default Projects;
